export class TableCalculationsUtils {
  constructor() { }

  private pointsCalculationStrategies = {
    acceptedPercentage: 'calculatePercentageGreterBetterScore',
    refusedPercentage: 'calculatePercentageLowerBetterScore',
    completedPercentage: 'calculatePercentageGreterBetterScore',
    incompletedPercentage: 'calculatePercentageLowerBetterScore',
    averageRating: 'calculateStarScore',
    responseOnTimePercentage: 'calculatePercentageGreterBetterScore',
    solutionOnTimePercentage: 'calculatePercentageGreterBetterScore',
    requestedInterval: 'calculateMeanTimeScoreInSeconds',
    onNegotiationInterval: 'calculateMeanTimeScoreInSeconds',
    pendingInterval: 'calculateMeanTimeScoreInSeconds',
    scheduledInterval: 'calculateMeanTimeScoreInSeconds',
    inProgressInterval: 'calculateMeanTimeScoreInSeconds',
    reportedInterval: 'calculateMeanTimeScoreInSeconds',
    responseInterval: 'calculateMeanTimeScoreInSeconds',
    solutionInterval: 'calculateMeanTimeScoreInSeconds',
    averageResponseTimeInDays: 'calculateMeanTimeScoreInDays',
    averageCloseTimeInDays: 'calculateMeanTimeScoreInDays',
    responseOnTimePercentageByRange: 'calculatePercentageByRange',
    solutionOnTimePercentageByRange: 'calculatePercentageByRange',
  };

  private discountCalculationStrategies = {
    responseOnTimePercentageByRange: 'calculateDiscountByPercentageByRange',
    solutionOnTimePercentageByRange: 'calculateDiscountByPercentageByRange',
  };


  public getTotalPoints(criterias: { [key: string]: { title: string, points: number } }): number {
    let totalPoints = 0;

    for (const key in criterias) {
      if (criterias.hasOwnProperty(key)) {
        totalPoints += criterias[key].points;
      }
    }

    return totalPoints;
  }

  public getTotalDiscount(criterias: { [key: string]: { title: string, points: number, discount?: number} }): number {
    let totalDiscount = 0;

    for (const key in criterias) {
      if (criterias.hasOwnProperty(key)) {
        totalDiscount += criterias[key].discount || 0;
      }
    }

    return totalDiscount;
  }

  public calculatePercentageGreterBetterScore(acceptedPercentage, points): number {
    return (acceptedPercentage * points) / 100;
  }

  public calculatePercentageLowerBetterScore(acceptedPercentage, points): number {
    return ((100 - acceptedPercentage) * points) / 100;
  }

  public calculateMeanTimeScoreInDays(days, maxHours, maxScore): number {
    const hours = days * 24;
    if (hours <= maxHours) {
      return maxScore;
    }

    return (maxHours / hours) * maxScore;
  }

  public calculateMeanTimeScoreInSeconds(seconds, maxHours, maxScore): number {
    const hours = seconds / 3600;
    if (hours <= maxHours) {
      return maxScore;
    }

    return (maxHours / hours) * maxScore;
  }

  public calculatePercentageByRange(value, matchingCriteria): number {
    for (const range of matchingCriteria.value.percentRange) {
      const start = range.start < range.end ? range.start : range.end;
      const end = range.start > range.end ? range.start : range.end;

      if (value >= start && value <= end) {
        return range.points;
      }
    }

    return 0;
  }

  public calculateDiscountByPercentageByRange(value, matchingCriteria): number {
    for (const range of matchingCriteria.value.percentRange) {
      const start = range.start < range.end ? range.start : range.end;
      const end = range.start > range.end ? range.start : range.end;

      if (value >= start && value <= end) {
        return range.discount;
      }
    }

    return 0;
  }

  public calculateStarScore(stars, maxScore): number {
    const maxStars = 5;
    if (stars >= maxStars) {
      return maxScore;
    }
    return (stars / maxStars) * maxScore;
  }

  public calculatePointsForCriteria(key: string, value: any, matchingCriteria: any): number {
    const strategy = this.pointsCalculationStrategies[key];
    const isMeanTimeScore = ['calculateMeanTimeScoreInSeconds', 'calculateMeanTimeScoreInDays'];
    const isRangePercent = ['calculatePercentageByRange'];
    if (!strategy) { return 0; }

    if (isRangePercent.includes(strategy)) {
      return this[strategy](value, matchingCriteria);
    }

    if (isMeanTimeScore.includes(strategy)) {
      return this[strategy](value, matchingCriteria.value.resultThreshold, matchingCriteria.value.points);
    }
    return this[strategy](value, matchingCriteria.value.points);
  }

  public calculateDiscountForCriteria(key: string, value: any, matchingCriteria: any): number {
    const strategy = this.discountCalculationStrategies[key];
    const isRangePercent = ['calculateDiscountByPercentageByRange'];

    if (!strategy) { return 0; }

    if (isRangePercent.includes(strategy)) {
      return this[strategy](value, matchingCriteria);
    }

    return 0;
  }
}
